export default "__VITE_ASSET__4c7fc80e__"